import React from "react";
import { Box, Grid, Typography, TextField, Divider } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";

const fieldSx = {
  "& .MuiOutlinedInput-root": {
    borderRadius: 1.5,
    backgroundColor: "#fff",
    "& fieldset": { borderColor: "#d1d5db" },
    "&:hover fieldset": { borderColor: "#163666" },
    "&.Mui-focused fieldset": { borderColor: "#163666", borderWidth: 2 },
    "&.Mui-error fieldset": { borderColor: "#ef4444 !important", borderWidth: "2px !important" },
    "&.Mui-disabled": { backgroundColor: "#f9fafb" },
  },
};

const Label = ({ children }) => (
  <Typography variant="body2" sx={{ mb: 0.875, fontWeight: 600, color: "#374151", fontSize: "0.825rem" }}>
    {children}
  </Typography>
);

export const MandatoryInfoSection = ({
  formData,
  handleInputChange,
  isEditable,
  validationErrors,
  t,
}) => (
  <>
    <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, mb: 3 }}>
      <Box sx={{ width: 3, height: 22, backgroundColor: "#163666", borderRadius: 2, flexShrink: 0 }} />
      <Typography variant="h6" sx={{ fontWeight: 700, color: "#1a1a2e" }}>
        {t.mandatoryInformation}
      </Typography>
      <Typography variant="body2" sx={{ color: "#ef4444", fontWeight: 600 }}>*</Typography>
    </Box>

    <Grid container spacing={2.5} sx={{ mb: 4 }}>
      <Grid size={{ xs: 12, sm: 4 }}>
        <Label>{t.firstName} <span style={{ color: "#ef4444" }}>*</span></Label>
        <TextField
          fullWidth
          size="small"
          placeholder={t.enterFirstName}
          value={formData.firstName}
          onChange={(e) => handleInputChange("firstName", e.target.value)}
          disabled={!isEditable}
          error={!!validationErrors.firstName}
          sx={fieldSx}
        />
      </Grid>

      <Grid size={{ xs: 12, sm: 4 }}>
        <Label>{t.lastName} <span style={{ color: "#ef4444" }}>*</span></Label>
        <TextField
          fullWidth
          size="small"
          placeholder={t.enterLastName}
          value={formData.lastName}
          onChange={(e) => handleInputChange("lastName", e.target.value)}
          disabled={!isEditable}
          error={!!validationErrors.lastName}
          sx={fieldSx}
        />
      </Grid>

      <Grid size={{ xs: 12, sm: 4 }}>
        <Label>{t.dateOfBirth} <span style={{ color: "#ef4444" }}>*</span></Label>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker
            value={formData.dateOfBirth ? dayjs(formData.dateOfBirth) : null}
            format="DD/MM/YYYY"
            onChange={(v) => handleInputChange("dateOfBirth", v ? v.format("YYYY-MM-DD") : "")}
            maxDate={dayjs()}
            disabled={!isEditable}
            slotProps={{
              textField: {
                fullWidth: true,
                size: "small",
                error: !!validationErrors.dateOfBirth,
                sx: fieldSx,
              },
            }}
          />
        </LocalizationProvider>
      </Grid>
    </Grid>

    <Divider sx={{ mb: 4, borderColor: "#dfdfdf" }} />
  </>
);
